export default "__VITE_ASSET__DgfaW4zf__"